import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { NamedLink } from '../../components';

import css from './TabNav.module.css';

const Tab = props => {
  const { className, id, disabled, text, selected, linkProps, isEditListingWizard, count } = props;
  const linkClasses = classNames(css.link, {
    [css.selectedLink]: selected,
    [css.disabled]: disabled,
  });
  const listingLinkClasses = classNames(css.listingLink, {
    [css.selectedListingLink]: selected,
    [css.disabledListingLink]: disabled,
  });

  return (
    <div id={id} className={className}>
      <NamedLink className={isEditListingWizard ? listingLinkClasses : linkClasses} {...linkProps}>
        {isEditListingWizard && (
          <span className={css.countTab}>{count}</span>
        )}
        {text}
      </NamedLink>
    </div>
  );
};

Tab.defaultProps = { className: null, disabled: false, selected: false };

const { arrayOf, bool, node, object, string, number } = PropTypes;

Tab.propTypes = {
  id: string.isRequired,
  className: string,
  text: node.isRequired,
  disabled: bool,
  selected: bool,
  linkProps: object.isRequired,
  count: number,
};

const TabNav = props => {
  const { className, rootClassName, tabRootClassName, tabs,userRole,isEditListingWizard } = props;
  const classes = classNames(rootClassName || css.root, className);
  const tabClasses = tabRootClassName || css.tab;
  return (
    <nav className={classes}>
      {tabs.map((tab, index) => {
        if(userRole != "photographer" && tab.id ==='StripePayoutPageTab') return
        const id = typeof tab.id === 'string' ? tab.id : `${index}`;
        return (
          <Tab
            isEditListingWizard={isEditListingWizard}
            key={id}
            id={id}
            className={tabClasses}
            count={index + 1}
            {...tab}
          />
        );
      })}
    </nav>
  );
};

TabNav.defaultProps = {
  className: null,
  rootClassName: null,
  tabRootClassName: null,
  tabClassName: null,
};

TabNav.propTypes = {
  className: string,
  rootClassName: string,
  tabRootClassName: string,
  tabs: arrayOf(object).isRequired,
};

export default TabNav;
